exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-filter[data-v-7fd11599] {\n  border: 0;\n  outline: 0;\n  color: #085FCE;\n  background-color: transparent;\n}", ""]);

// exports
